import React from 'react'

import type { DocumentFilter } from './documents/types'
import type { VideoFilter } from './videos/types'
import TextInput from '../../components/form/TextInput'
import { CategorySelectBox } from './categories'
import { default as VideoTypeSelectBox } from './videos/TypeSelectBox'
import { default as DocTypeSelectBox } from './documents/TypeSelectBox'
import { useI18N } from '../../../libraries/i18n/hook'
import DifficultyLevelSelectBox from './difficulty-level/SelectBox'
import Button from '../../components/form/Button'
import FiltersBox from '../../components/layout/FiltersBox'

type Props = { filters: Partial<VideoFilter> | Partial<DocumentFilter>, contentType: 'video' | 'document', onChange: (filters: Partial<VideoFilter> | Partial<DocumentFilter>) => void }
const ContentFilters: React.FC<Props> = ({ filters, contentType, onChange }) => {
  const [showFilters, setShowFilters] = React.useState(false)
  const { t } = useI18N()

  const handleTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const text = e.target.value
    onChange({ text })
  }

  const renderFilters = () => {
    return (
      <div className='my-6 w-full grid grid-cols-1 md:grid-cols-1 lg:grid-cols-12 gap-4'>
        <div className='md:col-span-6 lg:col-span-4'><TextInput className='w-full' value={filters.text ?? ''} placeholder={t('content.searchByKeyword')} onChange={handleTextChange}/></div>
        <div className='md:col-span-3 lg:col-span-2'><CategorySelectBox name='mainCategory' label={t('content.category')} values={filters.mainCategory ? filters.mainCategory : []} onChange={onChange} isMulti={false} /></div>
        <div className='md:col-span-3 lg:col-span-2'><CategorySelectBox name='categories' label={t('content.sector')} mainCategoryId={filters.mainCategory} values={filters.categories} onChange={onChange} isDisabled={!filters.mainCategory} /></div>
        {contentType === 'video' && <div className='md:col-span-3 lg:col-span-2'><VideoTypeSelectBox onChange={onChange} values={(filters as VideoFilter).videoTypes} /></div>}
        {contentType === 'document' && <div className='md:col-span-3 lg:col-span-2'><DocTypeSelectBox onChange={onChange} values={(filters as DocumentFilter).docTypes} /></div>}

        <div className='md:col-span-3 lg:col-span-2'><DifficultyLevelSelectBox onChange={onChange} values={filters.difficultyLevels} /></div>
        <div className='flex md:hidden justify-between mt-4'>
          <Button variant='secondary' outlined onClick={() => onChange({})}>{t('content.remove.filters')}</Button>
          <Button variant='primary' onClick={() => setShowFilters(false)}>{t('content.see.results')}</Button>
        </div>
      </div>
    )
  }

  return (
    <FiltersBox toggleShowFilters={setShowFilters} showFilters={showFilters}>
      {renderFilters()}
    </FiltersBox>
  )
}

export default ContentFilters
